import { withFormsy, propTypes } from "formsy-react";
import React from "react";
import ErrorLabel from "../../../common/errorLabel";
import Tooltip from "../../../common/tooltip";

class FileUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: props.formData && props.formData[props.name]
    };
    this.changeValue = this.changeValue.bind(this);
    this.resetFile = this.resetFile.bind(this);
  }
  changeValue(event) {
    let files = event.target.files;
    let file = files[0];
    if (files.length > 0) {
      this.setState({ file }, () => {
        this.props.setValue(this.state.file);
      });
    }
  }
  resetFile() {
    this.setState({ file: null }, () => {
      this.props.resetValue();
      this.props.formData[this.props.name].value = null;
      this[this.props.name].value = null;
    });
  }

  render() {
    const errorMessage = this.props.getErrorMessage();
    const {
      showRequired,
      showError,
      getValue,
      name,
      description,
      label,
      isPristine,
      isRequired,
      className,
      disableFields,
      acceptedFormats
    } = this.props;
    const { file } = this.state;
    const hasError =
      (!isPristine() && showError()) || (getValue() && showError());
    const requiredError = showRequired() && !isPristine();
    const acceptedFormatString = acceptedFormats && acceptedFormats.join(",");
    const acceptedFormatStringMinusDot = acceptedFormatString.replace(".", "");
    return (
      <div className="form-group">
        <label
          className={`input-control-label ${isRequired() ? "required" : ""}`}
          htmlFor={name}
        >
          {label}{" "}
          {description && (
            <Tooltip message={description} position={"bottom"}>
              (?)
            </Tooltip>
          )}
          <small>(Only {acceptedFormatStringMinusDot} files are allowed)</small>
        </label>
        <input
          accept={acceptedFormatString}
          type="file"
          id={name}
          className={`form-control ${
            hasError || requiredError ? "error" : ""
          } ${className}`}
          name={name}
          disabled={disableFields}
          onChange={this.changeValue}
          ref={c => {
            this[name] = c;
          }}
        />
        {file && (
          <div className="panel">
            <div className="panel-body">
              <div className="row">
                <div className="col-xs-8">
                  <strong>File name:</strong> {file.name}
                </div>
                <div className="col-xs-4 text-right">
                  <button
                    type="button"
                    onClick={this.resetFile}
                    className="btn btn-primary btn-sm"
                  >
                    Clear file
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        <ErrorLabel message={hasError ? errorMessage : ""} />
        <ErrorLabel message={requiredError ? "Required" : ""} />
      </div>
    );
  }
}

FileUpload.propTypes = {
  ...propTypes
};

export default withFormsy(FileUpload);



// WEBPACK FOOTER //
// ./src/components/discover/common/controls/FileUpload.js